export const YANDEX_STORY_MAX_NAME_LENGTH = 14;

// Seconds are irrelevant for scheduling and the default format does not fit the date fields.
export const YANDEX_STORY_DATE_TIME_FORMAT = 'DD.MM.YYYY HH:mm';
export const YANDEX_STORY_TIME_FORMAT = 'HH:mm';
